export enum FlightType {
  Domestic = 1,
  International,
  All,
}
